import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { useIntl } from 'react-intl';

import { FloorPlanButton, Footer, FloorPlanButtonIcon } from './styles';
import { useFloorPlanConfiguration } from 'floorplan/pages/floorplan/hooks/use-floorplan-configuration.hook';
import { push } from 'store/router/actions';

interface FloorPlanFooterParamsInterface {
  buttonTextId?: string;
}

export const FloorPlanFooter = ({ buttonTextId }: FloorPlanFooterParamsInterface): JSX.Element => {
  const dispatch = useDispatch();
  const { search } = useLocation();
  const intl = useIntl();
  const floorPlanEnabled = Boolean(useFloorPlanConfiguration());

  const onFloorPlanClick = useCallback(() => {
    dispatch(push(`/floorplan${search}`));
  }, []);

  return (
    floorPlanEnabled && (
      <Footer>
        {buttonTextId && (
          <FloorPlanButton
            size="floorPlan"
            data-testid="floor-plan-button"
            text={intl.formatMessage({ id: buttonTextId })}
            variant="floorPlan"
            multiline={false}
            onClick={onFloorPlanClick}
            iconDirection="left"
            Icon={<FloorPlanButtonIcon variant="white" />}
          />
        )}
      </Footer>
    )
  );
};
